angular.module('capability-ng-academic-planner').constant(
  'InTakeSurveyConstants',
  Object.freeze({
    AP_INTAKE_SURVEY_NK: 'academicplan-intake_survey_nk',
    AP_INTAKE_SURVEY_COMPLETED: 'AP_INTAKE_SURVEY_COMPLETED'
  })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/constants/intake_survey_constants.ts